module.exports = __webpack_public_path__ + "img/spainflag.9d735d91.svg";